import { render, staticRenderFns } from "./index.vue?vue&type=template&id=66e066ac&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=66e066ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e066ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/daniel/work/jiangxi/fed-sd-visual-web-static/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66e066ac')) {
      api.createRecord('66e066ac', component.options)
    } else {
      api.reload('66e066ac', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=66e066ac&scoped=true&", function () {
      api.rerender('66e066ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/government/home/index.vue"
export default component.exports